
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setShowSuccess(true);
      setEmail('');
      setTimeout(() => setShowSuccess(false), 3000);
    }
  };

  return (
    <footer className="bg-[#1A2332] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 600">
          <path
            d="M0,300 Q300,200 600,300 T1200,300"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          />
          <path
            d="M0,350 Q300,250 600,350 T1200,350"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12 mb-16">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6 cursor-pointer">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">T</span>
              </div>
              <span className="text-2xl font-bold">TGB Danışmanlık</span>
            </Link>
            <form onSubmit={handleSubmit} className="mb-6">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-posta adresinizi girin"
                  className="flex-1 px-4 py-3 bg-transparent border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 text-sm"
                  required
                />
                <button
                  type="submit"
                  className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer flex-shrink-0"
                >
                  <i className="ri-mail-send-line text-white text-xl"></i>
                </button>
              </div>
              {showSuccess && (
                <p className="text-green-400 text-sm mt-2">Abone olduğunuz için teşekkür ederiz!</p>
              )}
            </form>
            <p className="font-serif text-xl leading-relaxed text-gray-300">
              MSB, NATO ve Özel Tesis Güvenlik Belgesi süreçlerinde profesyonel danışmanlık hizmeti.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Hizmetlerimiz</h4>
            <ul className="space-y-3">
              <li>
                <a href="/hizmetler/milli-tgb" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Milli TGB
                </a>
              </li>
              <li>
                <a href="/hizmetler/nato-tgb" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  NATO TGB
                </a>
              </li>
              <li>
                <a href="/hizmetler/ozel-tgb" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Özel TGB
                </a>
              </li>
              <li>
                <a href="/hizmetler/belge-yenileme" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Belge Yenileme
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Kurumsal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Hakkımızda
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Referanslarımız
                </a>
              </li>
              <li>
                <a href="#insights" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Blog
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          {/* Yasal */}
          <div>
            <h4 className="font-bold text-lg mb-4">Yasal</h4>
            <ul className="space-y-3">
              <li>
                <a href="/gizlilik-politikasi" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Gizlilik Politikası
                </a>
              </li>
              <li>
                <a href="/kullanim-kosullari" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  Kullanım Koşulları
                </a>
              </li>
              <li>
                <a href="/kvkk" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
                  KVKK
                </a>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h4 className="font-bold text-lg mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-orange-500 mt-1"></i>
                <span className="text-gray-300 text-sm">
                  Konutkent Mahallesi 3028 Cadde 8C Daire 17 Çankaya / Ankara
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-orange-500"></i>
                <a href="tel:+903126660636" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">
                  0312 666 06 36
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-orange-500"></i>
                <a href="mailto:bilgi@tesisguvenlikbelgesi.com.tr" className="text-gray-300 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  bilgi@tesisguvenlikbelgesi.com.tr
                </a>
              </li>
              <li>
                <a href="/iletisim" className="inline-flex items-center gap-2 text-orange-500 hover:text-orange-400 font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  İletişim Sayfası
                  <i className="ri-arrow-right-line"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-700 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-gray-400 text-sm">
            © 2025 tesisguvenlikbelgesi.com.tr. Tüm hakları saklıdır.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer"
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer"
            >
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
